import { Button, Drawer, Space, Typography } from "antd";
import { useState } from "react";

export const Logout = () => {
  const [open, setOpen] = useState(false);

  const confirm = async () => {
    localStorage.removeItem('token');
    localStorage.removeItem('cleaner_id');

    window.location.reload();
  };

  return (
    <>
      <Typography.Text className="logout" onClick={() => setOpen(true)}>Выйти из аккаунта</Typography.Text>
      {/* <div className="gray">{localStorage.getItem('cleaner_id')}</div> */}
      <Drawer title="Выйти" onClose={() => setOpen(false)} open={open}>
        <Space direction="vertical" size="large">
          <div>Вы уверены, что хотите выйти из аккаунта?</div>
          <Button block type="primary" onClick={confirm}>
            Выйти
          </Button>
          <Button block onClick={() => setOpen(false)}>
            Отмена
          </Button>
        </Space>
      </Drawer>
    </>
  );
};
